module.exports = __webpack_public_path__ + "img/logo.fdb01036.png";